import Icon from '../components/Icon.vue'

Icon.register({
  dog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 96H432L424.8 81.7A32-32 0 0 1 396.2 64H342.6L315.3 36.7C305.2 26.6 288 33.8 288 48V197.9L416 243.6V208H448C483.4 208 512 179.4 512 144V112C512 103.2 504.8 96 496 96zM384 144C375.2 144 368 136.8 368 128S375.2 112 384 112 400 119.2 400 128 392.8 144 384 144zM96 224C78.4 224 64 209.6 64 192 64 174.3 49.7 160 32 160S0 174.3 0 192C0 233.7 26.8 268.9 64 282.1V496C64 504.8 71.2 512 80 512H144C152.8 512 160 504.8 160 496V384H320V496C320 504.8 327.2 512 336 512H400C408.8 512 416 504.8 416 496V277.6L266.1 224H96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dog.js
// module id = Lwe+
// module chunks = 144